import React, { useState, useEffect, useCallback } from 'react';
import { Col, Row, Typography } from 'antd';
import moment from 'moment';

import colors from '../../styles/colors';

import * as S from './styles';

const { Text } = Typography;

export function CaledarioFaixa({ title, change = () => { } }) {
  const [ranger, setRanger] = useState({ from: null, to: null });

  useEffect(() => {
    change(ranger);
  }, [ranger, change]);

  const handlerRanger = useCallback(
    e => {
      if (e) {
        const dateFrom = moment(e[0]._d).format('YYYY/MM/DD');
        const dateTo = moment(e[1]._d).format('YYYY/MM/DD');
        return setRanger({ from: dateFrom, to: dateTo });
      }
      if (!e) {
        return setRanger({ from: null, to: null });
      }
    },
    []
  );

  return (
    <Col>
      <Row justify="start" align="middle">
        <Text
          style={{
            color: colors.greyText,
            fontSize: 12,
          }}
        >
          {title || ''}
        </Text>
      </Row>
      <Row justify="end" align="middle">
        <S.RangePickerCustom format="DD/MMMM" onChange={handlerRanger} />
      </Row>
    </Col>
  );
}
